import { SlTitledListComponent } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import { propsFromTag } from 'shared/components/vxl/Tag/Tag.helpers';
import TransactionListItem from 'shared/components/vxl/TransactionListItem/TransactionListItem';
import theme from 'shared/styles/theme';
import { isNotNil } from 'shared/utils/isNotNil/isNotNil';

export interface LoanItemsProps {
  openLoans: SlTitledListComponent[];
}

const LoanItems = ({ openLoans }: LoanItemsProps) => {
  const router = useRouter();
  const allTransactions = openLoans.flatMap((section) => section.children);

  return (
    <>
      {allTransactions.map((transaction, index) => {
        const tags = transaction.tags?.map(propsFromTag).filter(isNotNil) ?? [];
        const isLastItem = index === allTransactions.length - 1;

        return (
          <React.Fragment key={transaction.id}>
            <TransactionListItem
              titleText={transaction.primaryText?.copy ?? ''}
              secondaryText={transaction.secondaryText?.copy ?? ''}
              amountText={transaction.primaryDetail?.copy ?? ''}
              balanceText={transaction.secondaryDetail?.copy ?? ''}
              tags={tags}
              onPress={() =>
                router.push({
                  pathname: '/pay-over-time/loan-details',
                  params: { loanId: transaction.id },
                })
              }
              amountStyle="NEUTRAL"
              isPending={false}
              showsChevron
            />
            {!isLastItem && (
              <View style={styles.dividerContainer}>
                <HairLineDivider />
              </View>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

const styles = StyleSheet.create({
  dividerContainer: {
    paddingHorizontal: theme.spacing.m,
  },
});

export default LoanItems;
